var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"btn faq-link d-flex",attrs:{"href":_vm.faqUrl,"target":"_blank"}},[_c('font-awesome-icon',{staticClass:"faq-link__icon mr-md-2",attrs:{"icon":['fas', 'question-circle']}}),_c('span',{staticClass:"d-none d-md-block"},[_vm._v(_vm._s(_vm.$t('general.help')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }